import React, { Component } from 'react';
import blank512x366 from '../../Common/blank-512x366.png';
import { CARD_NAMES } from '../../Common/CardUtilities';
import { getCardTextureId, getCardTextureUrl } from '../../Common/TextureTools';

import '../../Controls/tradelane-selector.css'

const SLIDING_ID = 19;

export default class TheRiverCard extends Component {

    constructor(props) {
        super(props);
        this.state = {reRenderCounter: 0}
        this.currentCard = props.tradelaneData.id;
    }

    removeAnimation = (displayCard, currentCard) => {
        if (currentCard !== displayCard) {
            this.setState({reRenderCount: ++this.state.reRenderCount});
        }
    }


    render() {
        const cardData = this.props.tradelaneData;
        const cardId = cardData.id;
        let displayCard = cardId;
        let animationClassName = null;
        if (this.props.animate) {
            let status = this.props.status;
            if (status === SLIDING_ID) {
                animationClassName = 'tradelane-slide-in';
            }
            // The old in-lane BURNING branch (status 18 + burn lane + nulled
            // card → 'tradelane-burn-animation') was removed by
            // CC_RIVER_BURN_GHOST_OVERLAY. With CC_RIVER_AUTO_PACE_COALESCE's
            // latest-state-wins gate, SLIDING (19) always lands behind
            // BURNING (18) in the pending slot, so the consumed BURNING state
            // effectively never animated here — burns silently fell through
            // to the generic exit (reading as an Advertisement discard). The
            // burn now plays as a non-blocking burn ghost overlaid by
            // TheRiver; keeping this branch would double-play it.
            if (animationClassName === null && this.currentCard !== cardId) {
                if (cardId !== null) {
                    // enter
                    animationClassName = 'tradelane-enter-animation';
                } else {
                    animationClassName = 'tradelane-exit-animation';
                    // exit
                    displayCard = this.currentCard;
                }
            }
        }

        let src;
        let isVideo = false;
        let name = 'No Card';
        let textureId = '';
        let staticImage = null;
        if (displayCard) {
            staticImage = getCardTextureUrl(displayCard);
            src = staticImage;
            textureId = getCardTextureId(displayCard);
            if (cardId) {
                name = `${CARD_NAMES[cardId]} (${cardId}/${textureId})`;
            }
        } else {
            src = blank512x366;
        }
        this.currentCard = cardId;

        return <div className={animationClassName}
                    id={`animation-wrapper--${cardData.tradelaneIndex}`}
                    onAnimationEnd={() => {
                        this.removeAnimation(displayCard, cardId)
                    }}
        >
            {isVideo &&
                <video width="100%" loop autoPlay muted
                       disableRemotePlayback={true}
                       className={'tradelane-card-video'}
                       onClick={this.props.onClick}
                       title={name}>
                    <source src={src} type="video/mp4"/>
                    <img src={staticImage} title={name} alt={name}/>
                </video>
            }
            {!isVideo &&
                <img className={'tradelane-selector-image'}
                     id={`item-image--${cardData.tradelaneIndex}`}
                     src={src}
                     alt={'card'}
                     data-tname={textureId || undefined}
                     onClick={this.props.onClick}
                     title={name}
                />
            }
        </div>;
    }
}
